import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = {
  role: "main",
  class: "main"
}

import Header from '@/layouts/LayoutHeader.vue';
import Footer from '@/layouts/LayoutFooter.vue';
import ProgressReading from "@/components/ProgressReading.vue";
import {useAppConfigStore} from "@/stores/app-config.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appConfig = useAppConfigStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ProgressReading),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, {
        appConfig: _unref(appConfig).data
      }, null, 8, ["appConfig"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(Footer, {
        appConfig: _unref(appConfig).data
      }, null, 8, ["appConfig"])
    ])
  ], 64))
}
}

})